export const SECTION_NAVIGATION_EVENT = "4sisters:section-navigation";

export function scrollToSection(selector: string) {
  const element = document.querySelector(selector);
  if (!element) return;

  window.dispatchEvent(
    new CustomEvent(SECTION_NAVIGATION_EVENT, {
      detail: { id: selector.replace(/^#/, "") },
    }),
  );
  element.scrollIntoView({ behavior: "smooth", block: "start" });
}
